import { createContext, useContext, useEffect, useState } from "react";
import api, { wishlistUtils } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("vf_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      wishlistUtils.refresh();
    }).catch(() => localStorage.removeItem("vf_token")).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("vf_token", r.data.token);
    setUser(r.data.user);
    wishlistUtils.refresh();
    return r.data.user;
  };
  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    localStorage.setItem("vf_token", r.data.token);
    setUser(r.data.user);
    wishlistUtils.refresh();
    return r.data.user;
  };
  const logout = () => { localStorage.removeItem("vf_token"); setUser(null); wishlistUtils.clear(); };

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
